<script lang="ts">
export default {
    name: 'BaseEmptyStatus',
};
</script>
<script lang="ts" setup>
import { computed, useSlots } from 'vue-demi';
import Button from '@pet/base.button/index.vue';
import type { IconName, StatusType } from './types';
import Icon from './icons.vue';

interface StatusProps {
    /**
     *  状态类型
     */
    type?: StatusType;
    /**
     *  Icon名称
     */
    icon?: IconName;
    /**
     *  是否包含按钮
     */
    button?: boolean;
    /**
     *  按钮文案
     */
    buttonText?: string;
}

const props = withDefaults(defineProps<StatusProps>(), {
    type: 'inside',
    icon: 'network',
    button: false,
    buttonText: '刷新',
});

const emit = defineEmits<{
    (event: 'btn-click'): void;
}>();

const iconSize = computed(() => (props.type === 'inside' ? 'small' : 'large'));
const slots = useSlots();
const withSubMessage = computed(() => slots.subMessage && 'with-sub-message');
</script>

<template>
    <div class="status-wrap">
        <div class="status-main">
            <div v-if="$slots.icon" class="icon-wrapper" :class="`icon-size-${iconSize}`">
                <slot name="icon" />
            </div>

            <Icon v-else class="status-icon" :name="icon" :size="iconSize" />
            <div v-if="slots.default" class="status-message" :class="withSubMessage">
                <slot />
            </div>
            <div v-if="$slots.subMessage" class="status-sub-message">
                <slot name="subMessage" />
            </div>
            <div v-if="button" class="status-ctrl">
                <Button type="plain" size="s" class="status-btn" @click.stop="emit('btn-click')">
                    {{ buttonText }}
                </Button>
            </div>
        </div>
    </div>
</template>

<style lang="stylus" scoped>
$empty-status-font-color=var(--base-empty-status-font-color, currentColor)

.status-wrap
    display flex
    height 100%
    width 100%
    justify-content center
    align-items center
    color $empty-status-font-color
    .status-btn
        color currentColor
        font-weight 400
        >>> .btn-main-box
            font-weight 400
    .status-main
        font-size 28px
        margin 32px
        text-align center
    .status-ctrl
        display flex
        justify-content center
        margin-top 20px

.status-icon
    vertical-align top

.status-message
    text-align center
    margin-top 16px
    font-size 16px
    line-height 22px
    max-width 318px
    &.with-sub-message
        font-size 18px
        font-weight 700
        line-height 25px

.status-sub-message
    max-width 318px
    opacity 0.5
    font-size 15px
    line-height 21px
    margin-top 8px

.icon-wrapper
    margin auto
    >>> svg, img
        width 100%
        height 100%

$full-size = 96px
$small-size = 88px

.icon-size-small
    width $small-size
    height $small-size
.icon-size-large
    width $full-size
    height $full-size
</style>
